// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "transaction.proto" (package "transaction", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message transaction.FinancialIncomeData
 */
export interface FinancialIncomeData {
    /**
     * @generated from protobuf field: uint32 related_currency = 1
     */
    relatedCurrency: number;
}
/**
 * @generated from protobuf message transaction.MemberSplitValue
 */
export interface MemberSplitValue {
    /**
     * @generated from protobuf field: string email = 1
     */
    email: string;
    /**
     * @generated from protobuf field: optional uint32 split_value = 2
     */
    splitValue?: number;
}
/**
 * @generated from protobuf message transaction.SplitOverride
 */
export interface SplitOverride {
    /**
     * @generated from protobuf field: transaction.SplitTypeOverride split_type_override = 1
     */
    splitTypeOverride: SplitTypeOverride;
    /**
     * @generated from protobuf field: repeated transaction.MemberSplitValue member_split_values = 2
     */
    memberSplitValues: MemberSplitValue[];
}
/**
 * @generated from protobuf message transaction.TransactionGroupData
 */
export interface TransactionGroupData {
    /**
     * @generated from protobuf field: uint32 transaction_group = 1
     */
    transactionGroup: number;
    /**
     * @generated from protobuf field: optional transaction.SplitOverride split_override = 2
     */
    splitOverride?: SplitOverride;
}
/**
 * @generated from protobuf message transaction.Transaction
 */
export interface Transaction {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: uint32 amount = 2
     */
    amount: number;
    /**
     * @generated from protobuf field: uint32 currency = 3
     */
    currency: number;
    /**
     * @generated from protobuf field: optional uint32 sender = 4
     */
    sender?: number;
    /**
     * @generated from protobuf field: optional uint32 receiver = 5
     */
    receiver?: number;
    /**
     * @generated from protobuf field: optional uint32 category = 6
     */
    category?: number;
    /**
     * @generated from protobuf field: string date = 7
     */
    date: string;
    /**
     * @generated from protobuf field: string note = 8
     */
    note: string;
    /**
     * @generated from protobuf field: uint32 receiver_currency = 9
     */
    receiverCurrency: number;
    /**
     * @generated from protobuf field: uint32 receiver_amount = 10
     */
    receiverAmount: number;
    /**
     * @generated from protobuf field: optional transaction.FinancialIncomeData financial_income_data = 11
     */
    financialIncomeData?: FinancialIncomeData;
    /**
     * @generated from protobuf field: optional transaction.TransactionGroupData transaction_group_data = 12
     */
    transactionGroupData?: TransactionGroupData;
    /**
     * @generated from protobuf field: string owner = 13
     */
    owner: string;
}
/**
 * @generated from protobuf message transaction.GetAllTransactionsRequest
 */
export interface GetAllTransactionsRequest {
}
/**
 * @generated from protobuf message transaction.GetAllTransactionsResponse
 */
export interface GetAllTransactionsResponse {
    /**
     * @generated from protobuf field: repeated transaction.Transaction transactions = 1
     */
    transactions: Transaction[];
}
/**
 * @generated from protobuf message transaction.CreateTransactionRequest
 */
export interface CreateTransactionRequest {
    /**
     * @generated from protobuf field: uint32 amount = 1
     */
    amount: number;
    /**
     * @generated from protobuf field: uint32 currency = 2
     */
    currency: number;
    /**
     * @generated from protobuf field: optional uint32 sender = 3
     */
    sender?: number;
    /**
     * @generated from protobuf field: optional uint32 receiver = 4
     */
    receiver?: number;
    /**
     * @generated from protobuf field: optional uint32 category = 5
     */
    category?: number;
    /**
     * @generated from protobuf field: string date = 6
     */
    date: string;
    /**
     * @generated from protobuf field: string note = 7
     */
    note: string;
    /**
     * @generated from protobuf field: uint32 receiver_currency = 8
     */
    receiverCurrency: number;
    /**
     * @generated from protobuf field: uint32 receiver_amount = 9
     */
    receiverAmount: number;
    /**
     * @generated from protobuf field: optional transaction.FinancialIncomeData financial_income_data = 10
     */
    financialIncomeData?: FinancialIncomeData;
    /**
     * @generated from protobuf field: optional transaction.TransactionGroupData transaction_group_data = 11
     */
    transactionGroupData?: TransactionGroupData;
    /**
     * @generated from protobuf field: string owner = 12
     */
    owner: string;
}
/**
 * @generated from protobuf message transaction.CreateTransactionResponse
 */
export interface CreateTransactionResponse {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message transaction.UpdateFinancialIncomeFields
 */
export interface UpdateFinancialIncomeFields {
    /**
     * @generated from protobuf field: optional uint32 related_currency = 1
     */
    relatedCurrency?: number;
}
/**
 * @generated from protobuf message transaction.UpdateMemberSplitValue
 */
export interface UpdateMemberSplitValue {
    /**
     * @generated from protobuf field: repeated transaction.MemberSplitValue member_split_values = 1
     */
    memberSplitValues: MemberSplitValue[];
}
/**
 * @generated from protobuf message transaction.UpdateSplitOverride
 */
export interface UpdateSplitOverride {
    /**
     * @generated from protobuf field: optional transaction.SplitTypeOverride split_type_override = 1
     */
    splitTypeOverride?: SplitTypeOverride;
    /**
     * @generated from protobuf field: optional transaction.UpdateMemberSplitValue update_member_split_values = 2
     */
    updateMemberSplitValues?: UpdateMemberSplitValue;
}
/**
 * @generated from protobuf message transaction.UpdateGroupedTransactionFields
 */
export interface UpdateGroupedTransactionFields {
    /**
     * @generated from protobuf field: optional uint32 transaction_group_id = 1
     */
    transactionGroupId?: number;
    /**
     * @generated from protobuf field: bool update_split_override = 2
     */
    updateSplitOverride: boolean;
    /**
     * @generated from protobuf field: optional transaction.UpdateSplitOverride update_split_override_fields = 3
     */
    updateSplitOverrideFields?: UpdateSplitOverride;
}
/**
 * @generated from protobuf message transaction.UpdateTransactionFields
 */
export interface UpdateTransactionFields {
    /**
     * @generated from protobuf field: optional uint32 amount = 1
     */
    amount?: number;
    /**
     * @generated from protobuf field: optional uint32 currency = 2
     */
    currency?: number;
    /**
     * @generated from protobuf field: bool update_sender = 3
     */
    updateSender: boolean;
    /**
     * @generated from protobuf field: optional uint32 sender = 4
     */
    sender?: number;
    /**
     * @generated from protobuf field: bool update_receiver = 5
     */
    updateReceiver: boolean;
    /**
     * @generated from protobuf field: optional uint32 receiver = 6
     */
    receiver?: number;
    /**
     * @generated from protobuf field: bool update_category = 7
     */
    updateCategory: boolean;
    /**
     * @generated from protobuf field: optional uint32 category = 8
     */
    category?: number;
    /**
     * @generated from protobuf field: optional string date = 9
     */
    date?: string;
    /**
     * @generated from protobuf field: optional string note = 10
     */
    note?: string;
    /**
     * @generated from protobuf field: optional uint32 receiver_currency = 11
     */
    receiverCurrency?: number;
    /**
     * @generated from protobuf field: optional uint32 receiver_amount = 12
     */
    receiverAmount?: number;
    /**
     * @generated from protobuf field: bool update_financial_income = 13
     */
    updateFinancialIncome: boolean;
    /**
     * @generated from protobuf field: optional transaction.UpdateFinancialIncomeFields update_financial_income_fields = 14
     */
    updateFinancialIncomeFields?: UpdateFinancialIncomeFields;
    /**
     * @generated from protobuf field: bool update_transaction_group = 15
     */
    updateTransactionGroup: boolean;
    /**
     * @generated from protobuf field: optional transaction.UpdateGroupedTransactionFields update_transaction_group_fields = 16
     */
    updateTransactionGroupFields?: UpdateGroupedTransactionFields;
}
/**
 * @generated from protobuf message transaction.UpdateTransactionRequest
 */
export interface UpdateTransactionRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: transaction.UpdateTransactionFields fields = 2
     */
    fields?: UpdateTransactionFields;
}
/**
 * @generated from protobuf message transaction.UpdateTransactionResponse
 */
export interface UpdateTransactionResponse {
}
/**
 * @generated from protobuf message transaction.DeleteTransactionRequest
 */
export interface DeleteTransactionRequest {
    /**
     * @generated from protobuf field: uint32 id = 1
     */
    id: number;
}
/**
 * @generated from protobuf message transaction.DeleteTransactionResponse
 */
export interface DeleteTransactionResponse {
}
/**
 * @generated from protobuf message transaction.ImportRow
 */
export interface ImportRow {
    /**
     * @generated from protobuf field: transaction.CreateTransactionRequest transaction = 1
     */
    transaction?: CreateTransactionRequest;
    /**
     * @generated from protobuf field: string fingerprint = 2
     */
    fingerprint: string;
    /**
     * @generated from protobuf field: string statement_name = 3
     */
    statementName: string;
    /**
     * @generated from protobuf field: optional uint32 merge_into = 4
     */
    mergeInto?: number;
    /**
     * @generated from protobuf field: string account_name = 5
     */
    accountName: string;
}
/**
 * @generated from protobuf message transaction.BatchCreateTransactionsRequest
 */
export interface BatchCreateTransactionsRequest {
    /**
     * @generated from protobuf field: uint32 import_id = 1
     */
    importId: number;
    /**
     * @generated from protobuf field: repeated transaction.ImportRow rows = 2
     */
    rows: ImportRow[];
}
/**
 * @generated from protobuf message transaction.ImportRowResult
 */
export interface ImportRowResult {
    /**
     * @generated from protobuf field: transaction.ImportRowOutcome outcome = 1
     */
    outcome: ImportRowOutcome;
    /**
     * @generated from protobuf field: uint32 transaction_id = 2
     */
    transactionId: number;
}
/**
 * @generated from protobuf message transaction.AccountStatementNames
 */
export interface AccountStatementNames {
    /**
     * @generated from protobuf field: uint32 account = 1
     */
    account: number;
    /**
     * @generated from protobuf field: repeated string statement_names = 2
     */
    statementNames: string[];
}
/**
 * @generated from protobuf message transaction.BatchCreateTransactionsResponse
 */
export interface BatchCreateTransactionsResponse {
    /**
     * @generated from protobuf field: repeated transaction.ImportRowResult results = 1
     */
    results: ImportRowResult[];
    /**
     * @generated from protobuf field: repeated transaction.AccountStatementNames accounts = 2
     */
    accounts: AccountStatementNames[];
}
/**
 * @generated from protobuf enum transaction.SplitTypeOverride
 */
export enum SplitTypeOverride {
    /**
     * @generated from protobuf enum value: OverrideEqual = 0;
     */
    OverrideEqual = 0,
    /**
     * @generated from protobuf enum value: OverridePercentage = 1;
     */
    OverridePercentage = 1,
    /**
     * @generated from protobuf enum value: OverrideShare = 2;
     */
    OverrideShare = 2,
    /**
     * @generated from protobuf enum value: OverrideExactAmount = 3;
     */
    OverrideExactAmount = 3
}
/**
 * @generated from protobuf enum transaction.ImportRowOutcome
 */
export enum ImportRowOutcome {
    /**
     * @generated from protobuf enum value: ImportRowCreated = 0;
     */
    ImportRowCreated = 0,
    /**
     * @generated from protobuf enum value: ImportRowMerged = 1;
     */
    ImportRowMerged = 1,
    /**
     * @generated from protobuf enum value: ImportRowSkipped = 2;
     */
    ImportRowSkipped = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class FinancialIncomeData$Type extends MessageType<FinancialIncomeData> {
    constructor() {
        super("transaction.FinancialIncomeData", [
            { no: 1, name: "related_currency", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<FinancialIncomeData>): FinancialIncomeData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.relatedCurrency = 0;
        if (value !== undefined)
            reflectionMergePartial<FinancialIncomeData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FinancialIncomeData): FinancialIncomeData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 related_currency */ 1:
                    message.relatedCurrency = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FinancialIncomeData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 related_currency = 1; */
        if (message.relatedCurrency !== 0)
            writer.tag(1, WireType.Varint).uint32(message.relatedCurrency);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.FinancialIncomeData
 */
export const FinancialIncomeData = new FinancialIncomeData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MemberSplitValue$Type extends MessageType<MemberSplitValue> {
    constructor() {
        super("transaction.MemberSplitValue", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "split_value", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<MemberSplitValue>): MemberSplitValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.email = "";
        if (value !== undefined)
            reflectionMergePartial<MemberSplitValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MemberSplitValue): MemberSplitValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* optional uint32 split_value */ 2:
                    message.splitValue = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MemberSplitValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* optional uint32 split_value = 2; */
        if (message.splitValue !== undefined)
            writer.tag(2, WireType.Varint).uint32(message.splitValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.MemberSplitValue
 */
export const MemberSplitValue = new MemberSplitValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SplitOverride$Type extends MessageType<SplitOverride> {
    constructor() {
        super("transaction.SplitOverride", [
            { no: 1, name: "split_type_override", kind: "enum", T: () => ["transaction.SplitTypeOverride", SplitTypeOverride] },
            { no: 2, name: "member_split_values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MemberSplitValue }
        ]);
    }
    create(value?: PartialMessage<SplitOverride>): SplitOverride {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.splitTypeOverride = 0;
        message.memberSplitValues = [];
        if (value !== undefined)
            reflectionMergePartial<SplitOverride>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SplitOverride): SplitOverride {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* transaction.SplitTypeOverride split_type_override */ 1:
                    message.splitTypeOverride = reader.int32();
                    break;
                case /* repeated transaction.MemberSplitValue member_split_values */ 2:
                    message.memberSplitValues.push(MemberSplitValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SplitOverride, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* transaction.SplitTypeOverride split_type_override = 1; */
        if (message.splitTypeOverride !== 0)
            writer.tag(1, WireType.Varint).int32(message.splitTypeOverride);
        /* repeated transaction.MemberSplitValue member_split_values = 2; */
        for (let i = 0; i < message.memberSplitValues.length; i++)
            MemberSplitValue.internalBinaryWrite(message.memberSplitValues[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.SplitOverride
 */
export const SplitOverride = new SplitOverride$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransactionGroupData$Type extends MessageType<TransactionGroupData> {
    constructor() {
        super("transaction.TransactionGroupData", [
            { no: 1, name: "transaction_group", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "split_override", kind: "message", T: () => SplitOverride }
        ]);
    }
    create(value?: PartialMessage<TransactionGroupData>): TransactionGroupData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactionGroup = 0;
        if (value !== undefined)
            reflectionMergePartial<TransactionGroupData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TransactionGroupData): TransactionGroupData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 transaction_group */ 1:
                    message.transactionGroup = reader.uint32();
                    break;
                case /* optional transaction.SplitOverride split_override */ 2:
                    message.splitOverride = SplitOverride.internalBinaryRead(reader, reader.uint32(), options, message.splitOverride);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TransactionGroupData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 transaction_group = 1; */
        if (message.transactionGroup !== 0)
            writer.tag(1, WireType.Varint).uint32(message.transactionGroup);
        /* optional transaction.SplitOverride split_override = 2; */
        if (message.splitOverride)
            SplitOverride.internalBinaryWrite(message.splitOverride, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.TransactionGroupData
 */
export const TransactionGroupData = new TransactionGroupData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Transaction$Type extends MessageType<Transaction> {
    constructor() {
        super("transaction.Transaction", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "currency", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "sender", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "receiver", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "category", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "receiver_currency", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 10, name: "receiver_amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 11, name: "financial_income_data", kind: "message", T: () => FinancialIncomeData },
            { no: 12, name: "transaction_group_data", kind: "message", T: () => TransactionGroupData },
            { no: 13, name: "owner", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Transaction>): Transaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.amount = 0;
        message.currency = 0;
        message.date = "";
        message.note = "";
        message.receiverCurrency = 0;
        message.receiverAmount = 0;
        message.owner = "";
        if (value !== undefined)
            reflectionMergePartial<Transaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Transaction): Transaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* uint32 amount */ 2:
                    message.amount = reader.uint32();
                    break;
                case /* uint32 currency */ 3:
                    message.currency = reader.uint32();
                    break;
                case /* optional uint32 sender */ 4:
                    message.sender = reader.uint32();
                    break;
                case /* optional uint32 receiver */ 5:
                    message.receiver = reader.uint32();
                    break;
                case /* optional uint32 category */ 6:
                    message.category = reader.uint32();
                    break;
                case /* string date */ 7:
                    message.date = reader.string();
                    break;
                case /* string note */ 8:
                    message.note = reader.string();
                    break;
                case /* uint32 receiver_currency */ 9:
                    message.receiverCurrency = reader.uint32();
                    break;
                case /* uint32 receiver_amount */ 10:
                    message.receiverAmount = reader.uint32();
                    break;
                case /* optional transaction.FinancialIncomeData financial_income_data */ 11:
                    message.financialIncomeData = FinancialIncomeData.internalBinaryRead(reader, reader.uint32(), options, message.financialIncomeData);
                    break;
                case /* optional transaction.TransactionGroupData transaction_group_data */ 12:
                    message.transactionGroupData = TransactionGroupData.internalBinaryRead(reader, reader.uint32(), options, message.transactionGroupData);
                    break;
                case /* string owner */ 13:
                    message.owner = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Transaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* uint32 amount = 2; */
        if (message.amount !== 0)
            writer.tag(2, WireType.Varint).uint32(message.amount);
        /* uint32 currency = 3; */
        if (message.currency !== 0)
            writer.tag(3, WireType.Varint).uint32(message.currency);
        /* optional uint32 sender = 4; */
        if (message.sender !== undefined)
            writer.tag(4, WireType.Varint).uint32(message.sender);
        /* optional uint32 receiver = 5; */
        if (message.receiver !== undefined)
            writer.tag(5, WireType.Varint).uint32(message.receiver);
        /* optional uint32 category = 6; */
        if (message.category !== undefined)
            writer.tag(6, WireType.Varint).uint32(message.category);
        /* string date = 7; */
        if (message.date !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.date);
        /* string note = 8; */
        if (message.note !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.note);
        /* uint32 receiver_currency = 9; */
        if (message.receiverCurrency !== 0)
            writer.tag(9, WireType.Varint).uint32(message.receiverCurrency);
        /* uint32 receiver_amount = 10; */
        if (message.receiverAmount !== 0)
            writer.tag(10, WireType.Varint).uint32(message.receiverAmount);
        /* optional transaction.FinancialIncomeData financial_income_data = 11; */
        if (message.financialIncomeData)
            FinancialIncomeData.internalBinaryWrite(message.financialIncomeData, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* optional transaction.TransactionGroupData transaction_group_data = 12; */
        if (message.transactionGroupData)
            TransactionGroupData.internalBinaryWrite(message.transactionGroupData, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* string owner = 13; */
        if (message.owner !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.owner);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.Transaction
 */
export const Transaction = new Transaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllTransactionsRequest$Type extends MessageType<GetAllTransactionsRequest> {
    constructor() {
        super("transaction.GetAllTransactionsRequest", []);
    }
    create(value?: PartialMessage<GetAllTransactionsRequest>): GetAllTransactionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAllTransactionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllTransactionsRequest): GetAllTransactionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllTransactionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.GetAllTransactionsRequest
 */
export const GetAllTransactionsRequest = new GetAllTransactionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllTransactionsResponse$Type extends MessageType<GetAllTransactionsResponse> {
    constructor() {
        super("transaction.GetAllTransactionsResponse", [
            { no: 1, name: "transactions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Transaction }
        ]);
    }
    create(value?: PartialMessage<GetAllTransactionsResponse>): GetAllTransactionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactions = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllTransactionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllTransactionsResponse): GetAllTransactionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated transaction.Transaction transactions */ 1:
                    message.transactions.push(Transaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllTransactionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated transaction.Transaction transactions = 1; */
        for (let i = 0; i < message.transactions.length; i++)
            Transaction.internalBinaryWrite(message.transactions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.GetAllTransactionsResponse
 */
export const GetAllTransactionsResponse = new GetAllTransactionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateTransactionRequest$Type extends MessageType<CreateTransactionRequest> {
    constructor() {
        super("transaction.CreateTransactionRequest", [
            { no: 1, name: "amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "currency", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "sender", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "receiver", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "category", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "receiver_currency", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 9, name: "receiver_amount", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 10, name: "financial_income_data", kind: "message", T: () => FinancialIncomeData },
            { no: 11, name: "transaction_group_data", kind: "message", T: () => TransactionGroupData },
            { no: 12, name: "owner", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateTransactionRequest>): CreateTransactionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.amount = 0;
        message.currency = 0;
        message.date = "";
        message.note = "";
        message.receiverCurrency = 0;
        message.receiverAmount = 0;
        message.owner = "";
        if (value !== undefined)
            reflectionMergePartial<CreateTransactionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateTransactionRequest): CreateTransactionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 amount */ 1:
                    message.amount = reader.uint32();
                    break;
                case /* uint32 currency */ 2:
                    message.currency = reader.uint32();
                    break;
                case /* optional uint32 sender */ 3:
                    message.sender = reader.uint32();
                    break;
                case /* optional uint32 receiver */ 4:
                    message.receiver = reader.uint32();
                    break;
                case /* optional uint32 category */ 5:
                    message.category = reader.uint32();
                    break;
                case /* string date */ 6:
                    message.date = reader.string();
                    break;
                case /* string note */ 7:
                    message.note = reader.string();
                    break;
                case /* uint32 receiver_currency */ 8:
                    message.receiverCurrency = reader.uint32();
                    break;
                case /* uint32 receiver_amount */ 9:
                    message.receiverAmount = reader.uint32();
                    break;
                case /* optional transaction.FinancialIncomeData financial_income_data */ 10:
                    message.financialIncomeData = FinancialIncomeData.internalBinaryRead(reader, reader.uint32(), options, message.financialIncomeData);
                    break;
                case /* optional transaction.TransactionGroupData transaction_group_data */ 11:
                    message.transactionGroupData = TransactionGroupData.internalBinaryRead(reader, reader.uint32(), options, message.transactionGroupData);
                    break;
                case /* string owner */ 12:
                    message.owner = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateTransactionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 amount = 1; */
        if (message.amount !== 0)
            writer.tag(1, WireType.Varint).uint32(message.amount);
        /* uint32 currency = 2; */
        if (message.currency !== 0)
            writer.tag(2, WireType.Varint).uint32(message.currency);
        /* optional uint32 sender = 3; */
        if (message.sender !== undefined)
            writer.tag(3, WireType.Varint).uint32(message.sender);
        /* optional uint32 receiver = 4; */
        if (message.receiver !== undefined)
            writer.tag(4, WireType.Varint).uint32(message.receiver);
        /* optional uint32 category = 5; */
        if (message.category !== undefined)
            writer.tag(5, WireType.Varint).uint32(message.category);
        /* string date = 6; */
        if (message.date !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.date);
        /* string note = 7; */
        if (message.note !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.note);
        /* uint32 receiver_currency = 8; */
        if (message.receiverCurrency !== 0)
            writer.tag(8, WireType.Varint).uint32(message.receiverCurrency);
        /* uint32 receiver_amount = 9; */
        if (message.receiverAmount !== 0)
            writer.tag(9, WireType.Varint).uint32(message.receiverAmount);
        /* optional transaction.FinancialIncomeData financial_income_data = 10; */
        if (message.financialIncomeData)
            FinancialIncomeData.internalBinaryWrite(message.financialIncomeData, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* optional transaction.TransactionGroupData transaction_group_data = 11; */
        if (message.transactionGroupData)
            TransactionGroupData.internalBinaryWrite(message.transactionGroupData, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string owner = 12; */
        if (message.owner !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.owner);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.CreateTransactionRequest
 */
export const CreateTransactionRequest = new CreateTransactionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateTransactionResponse$Type extends MessageType<CreateTransactionResponse> {
    constructor() {
        super("transaction.CreateTransactionResponse", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<CreateTransactionResponse>): CreateTransactionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateTransactionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateTransactionResponse): CreateTransactionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateTransactionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.CreateTransactionResponse
 */
export const CreateTransactionResponse = new CreateTransactionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateFinancialIncomeFields$Type extends MessageType<UpdateFinancialIncomeFields> {
    constructor() {
        super("transaction.UpdateFinancialIncomeFields", [
            { no: 1, name: "related_currency", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateFinancialIncomeFields>): UpdateFinancialIncomeFields {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateFinancialIncomeFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateFinancialIncomeFields): UpdateFinancialIncomeFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional uint32 related_currency */ 1:
                    message.relatedCurrency = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateFinancialIncomeFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional uint32 related_currency = 1; */
        if (message.relatedCurrency !== undefined)
            writer.tag(1, WireType.Varint).uint32(message.relatedCurrency);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateFinancialIncomeFields
 */
export const UpdateFinancialIncomeFields = new UpdateFinancialIncomeFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMemberSplitValue$Type extends MessageType<UpdateMemberSplitValue> {
    constructor() {
        super("transaction.UpdateMemberSplitValue", [
            { no: 1, name: "member_split_values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MemberSplitValue }
        ]);
    }
    create(value?: PartialMessage<UpdateMemberSplitValue>): UpdateMemberSplitValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.memberSplitValues = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateMemberSplitValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateMemberSplitValue): UpdateMemberSplitValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated transaction.MemberSplitValue member_split_values */ 1:
                    message.memberSplitValues.push(MemberSplitValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateMemberSplitValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated transaction.MemberSplitValue member_split_values = 1; */
        for (let i = 0; i < message.memberSplitValues.length; i++)
            MemberSplitValue.internalBinaryWrite(message.memberSplitValues[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateMemberSplitValue
 */
export const UpdateMemberSplitValue = new UpdateMemberSplitValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSplitOverride$Type extends MessageType<UpdateSplitOverride> {
    constructor() {
        super("transaction.UpdateSplitOverride", [
            { no: 1, name: "split_type_override", kind: "enum", opt: true, T: () => ["transaction.SplitTypeOverride", SplitTypeOverride] },
            { no: 2, name: "update_member_split_values", kind: "message", T: () => UpdateMemberSplitValue }
        ]);
    }
    create(value?: PartialMessage<UpdateSplitOverride>): UpdateSplitOverride {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateSplitOverride>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateSplitOverride): UpdateSplitOverride {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional transaction.SplitTypeOverride split_type_override */ 1:
                    message.splitTypeOverride = reader.int32();
                    break;
                case /* optional transaction.UpdateMemberSplitValue update_member_split_values */ 2:
                    message.updateMemberSplitValues = UpdateMemberSplitValue.internalBinaryRead(reader, reader.uint32(), options, message.updateMemberSplitValues);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateSplitOverride, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional transaction.SplitTypeOverride split_type_override = 1; */
        if (message.splitTypeOverride !== undefined)
            writer.tag(1, WireType.Varint).int32(message.splitTypeOverride);
        /* optional transaction.UpdateMemberSplitValue update_member_split_values = 2; */
        if (message.updateMemberSplitValues)
            UpdateMemberSplitValue.internalBinaryWrite(message.updateMemberSplitValues, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateSplitOverride
 */
export const UpdateSplitOverride = new UpdateSplitOverride$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateGroupedTransactionFields$Type extends MessageType<UpdateGroupedTransactionFields> {
    constructor() {
        super("transaction.UpdateGroupedTransactionFields", [
            { no: 1, name: "transaction_group_id", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "update_split_override", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "update_split_override_fields", kind: "message", T: () => UpdateSplitOverride }
        ]);
    }
    create(value?: PartialMessage<UpdateGroupedTransactionFields>): UpdateGroupedTransactionFields {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.updateSplitOverride = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateGroupedTransactionFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateGroupedTransactionFields): UpdateGroupedTransactionFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional uint32 transaction_group_id */ 1:
                    message.transactionGroupId = reader.uint32();
                    break;
                case /* bool update_split_override */ 2:
                    message.updateSplitOverride = reader.bool();
                    break;
                case /* optional transaction.UpdateSplitOverride update_split_override_fields */ 3:
                    message.updateSplitOverrideFields = UpdateSplitOverride.internalBinaryRead(reader, reader.uint32(), options, message.updateSplitOverrideFields);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateGroupedTransactionFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional uint32 transaction_group_id = 1; */
        if (message.transactionGroupId !== undefined)
            writer.tag(1, WireType.Varint).uint32(message.transactionGroupId);
        /* bool update_split_override = 2; */
        if (message.updateSplitOverride !== false)
            writer.tag(2, WireType.Varint).bool(message.updateSplitOverride);
        /* optional transaction.UpdateSplitOverride update_split_override_fields = 3; */
        if (message.updateSplitOverrideFields)
            UpdateSplitOverride.internalBinaryWrite(message.updateSplitOverrideFields, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateGroupedTransactionFields
 */
export const UpdateGroupedTransactionFields = new UpdateGroupedTransactionFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateTransactionFields$Type extends MessageType<UpdateTransactionFields> {
    constructor() {
        super("transaction.UpdateTransactionFields", [
            { no: 1, name: "amount", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "currency", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "update_sender", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "sender", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "update_receiver", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "receiver", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "update_category", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "category", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 9, name: "date", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "note", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "receiver_currency", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 12, name: "receiver_amount", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 13, name: "update_financial_income", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "update_financial_income_fields", kind: "message", T: () => UpdateFinancialIncomeFields },
            { no: 15, name: "update_transaction_group", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "update_transaction_group_fields", kind: "message", T: () => UpdateGroupedTransactionFields }
        ]);
    }
    create(value?: PartialMessage<UpdateTransactionFields>): UpdateTransactionFields {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.updateSender = false;
        message.updateReceiver = false;
        message.updateCategory = false;
        message.updateFinancialIncome = false;
        message.updateTransactionGroup = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateTransactionFields>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateTransactionFields): UpdateTransactionFields {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional uint32 amount */ 1:
                    message.amount = reader.uint32();
                    break;
                case /* optional uint32 currency */ 2:
                    message.currency = reader.uint32();
                    break;
                case /* bool update_sender */ 3:
                    message.updateSender = reader.bool();
                    break;
                case /* optional uint32 sender */ 4:
                    message.sender = reader.uint32();
                    break;
                case /* bool update_receiver */ 5:
                    message.updateReceiver = reader.bool();
                    break;
                case /* optional uint32 receiver */ 6:
                    message.receiver = reader.uint32();
                    break;
                case /* bool update_category */ 7:
                    message.updateCategory = reader.bool();
                    break;
                case /* optional uint32 category */ 8:
                    message.category = reader.uint32();
                    break;
                case /* optional string date */ 9:
                    message.date = reader.string();
                    break;
                case /* optional string note */ 10:
                    message.note = reader.string();
                    break;
                case /* optional uint32 receiver_currency */ 11:
                    message.receiverCurrency = reader.uint32();
                    break;
                case /* optional uint32 receiver_amount */ 12:
                    message.receiverAmount = reader.uint32();
                    break;
                case /* bool update_financial_income */ 13:
                    message.updateFinancialIncome = reader.bool();
                    break;
                case /* optional transaction.UpdateFinancialIncomeFields update_financial_income_fields */ 14:
                    message.updateFinancialIncomeFields = UpdateFinancialIncomeFields.internalBinaryRead(reader, reader.uint32(), options, message.updateFinancialIncomeFields);
                    break;
                case /* bool update_transaction_group */ 15:
                    message.updateTransactionGroup = reader.bool();
                    break;
                case /* optional transaction.UpdateGroupedTransactionFields update_transaction_group_fields */ 16:
                    message.updateTransactionGroupFields = UpdateGroupedTransactionFields.internalBinaryRead(reader, reader.uint32(), options, message.updateTransactionGroupFields);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateTransactionFields, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional uint32 amount = 1; */
        if (message.amount !== undefined)
            writer.tag(1, WireType.Varint).uint32(message.amount);
        /* optional uint32 currency = 2; */
        if (message.currency !== undefined)
            writer.tag(2, WireType.Varint).uint32(message.currency);
        /* bool update_sender = 3; */
        if (message.updateSender !== false)
            writer.tag(3, WireType.Varint).bool(message.updateSender);
        /* optional uint32 sender = 4; */
        if (message.sender !== undefined)
            writer.tag(4, WireType.Varint).uint32(message.sender);
        /* bool update_receiver = 5; */
        if (message.updateReceiver !== false)
            writer.tag(5, WireType.Varint).bool(message.updateReceiver);
        /* optional uint32 receiver = 6; */
        if (message.receiver !== undefined)
            writer.tag(6, WireType.Varint).uint32(message.receiver);
        /* bool update_category = 7; */
        if (message.updateCategory !== false)
            writer.tag(7, WireType.Varint).bool(message.updateCategory);
        /* optional uint32 category = 8; */
        if (message.category !== undefined)
            writer.tag(8, WireType.Varint).uint32(message.category);
        /* optional string date = 9; */
        if (message.date !== undefined)
            writer.tag(9, WireType.LengthDelimited).string(message.date);
        /* optional string note = 10; */
        if (message.note !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.note);
        /* optional uint32 receiver_currency = 11; */
        if (message.receiverCurrency !== undefined)
            writer.tag(11, WireType.Varint).uint32(message.receiverCurrency);
        /* optional uint32 receiver_amount = 12; */
        if (message.receiverAmount !== undefined)
            writer.tag(12, WireType.Varint).uint32(message.receiverAmount);
        /* bool update_financial_income = 13; */
        if (message.updateFinancialIncome !== false)
            writer.tag(13, WireType.Varint).bool(message.updateFinancialIncome);
        /* optional transaction.UpdateFinancialIncomeFields update_financial_income_fields = 14; */
        if (message.updateFinancialIncomeFields)
            UpdateFinancialIncomeFields.internalBinaryWrite(message.updateFinancialIncomeFields, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* bool update_transaction_group = 15; */
        if (message.updateTransactionGroup !== false)
            writer.tag(15, WireType.Varint).bool(message.updateTransactionGroup);
        /* optional transaction.UpdateGroupedTransactionFields update_transaction_group_fields = 16; */
        if (message.updateTransactionGroupFields)
            UpdateGroupedTransactionFields.internalBinaryWrite(message.updateTransactionGroupFields, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateTransactionFields
 */
export const UpdateTransactionFields = new UpdateTransactionFields$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateTransactionRequest$Type extends MessageType<UpdateTransactionRequest> {
    constructor() {
        super("transaction.UpdateTransactionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "fields", kind: "message", T: () => UpdateTransactionFields }
        ]);
    }
    create(value?: PartialMessage<UpdateTransactionRequest>): UpdateTransactionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateTransactionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateTransactionRequest): UpdateTransactionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* transaction.UpdateTransactionFields fields */ 2:
                    message.fields = UpdateTransactionFields.internalBinaryRead(reader, reader.uint32(), options, message.fields);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateTransactionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* transaction.UpdateTransactionFields fields = 2; */
        if (message.fields)
            UpdateTransactionFields.internalBinaryWrite(message.fields, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateTransactionRequest
 */
export const UpdateTransactionRequest = new UpdateTransactionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateTransactionResponse$Type extends MessageType<UpdateTransactionResponse> {
    constructor() {
        super("transaction.UpdateTransactionResponse", []);
    }
    create(value?: PartialMessage<UpdateTransactionResponse>): UpdateTransactionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateTransactionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateTransactionResponse): UpdateTransactionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateTransactionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.UpdateTransactionResponse
 */
export const UpdateTransactionResponse = new UpdateTransactionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteTransactionRequest$Type extends MessageType<DeleteTransactionRequest> {
    constructor() {
        super("transaction.DeleteTransactionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteTransactionRequest>): DeleteTransactionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<DeleteTransactionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteTransactionRequest): DeleteTransactionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteTransactionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.DeleteTransactionRequest
 */
export const DeleteTransactionRequest = new DeleteTransactionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteTransactionResponse$Type extends MessageType<DeleteTransactionResponse> {
    constructor() {
        super("transaction.DeleteTransactionResponse", []);
    }
    create(value?: PartialMessage<DeleteTransactionResponse>): DeleteTransactionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteTransactionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteTransactionResponse): DeleteTransactionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteTransactionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.DeleteTransactionResponse
 */
export const DeleteTransactionResponse = new DeleteTransactionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportRow$Type extends MessageType<ImportRow> {
    constructor() {
        super("transaction.ImportRow", [
            { no: 1, name: "transaction", kind: "message", T: () => CreateTransactionRequest },
            { no: 2, name: "fingerprint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "statement_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "merge_into", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "account_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ImportRow>): ImportRow {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fingerprint = "";
        message.statementName = "";
        message.accountName = "";
        if (value !== undefined)
            reflectionMergePartial<ImportRow>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImportRow): ImportRow {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* transaction.CreateTransactionRequest transaction */ 1:
                    message.transaction = CreateTransactionRequest.internalBinaryRead(reader, reader.uint32(), options, message.transaction);
                    break;
                case /* string fingerprint */ 2:
                    message.fingerprint = reader.string();
                    break;
                case /* string statement_name */ 3:
                    message.statementName = reader.string();
                    break;
                case /* optional uint32 merge_into */ 4:
                    message.mergeInto = reader.uint32();
                    break;
                case /* string account_name */ 5:
                    message.accountName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImportRow, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* transaction.CreateTransactionRequest transaction = 1; */
        if (message.transaction)
            CreateTransactionRequest.internalBinaryWrite(message.transaction, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string fingerprint = 2; */
        if (message.fingerprint !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.fingerprint);
        /* string statement_name = 3; */
        if (message.statementName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.statementName);
        /* optional uint32 merge_into = 4; */
        if (message.mergeInto !== undefined)
            writer.tag(4, WireType.Varint).uint32(message.mergeInto);
        /* string account_name = 5; */
        if (message.accountName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.accountName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.ImportRow
 */
export const ImportRow = new ImportRow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchCreateTransactionsRequest$Type extends MessageType<BatchCreateTransactionsRequest> {
    constructor() {
        super("transaction.BatchCreateTransactionsRequest", [
            { no: 1, name: "import_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "rows", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ImportRow }
        ]);
    }
    create(value?: PartialMessage<BatchCreateTransactionsRequest>): BatchCreateTransactionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.importId = 0;
        message.rows = [];
        if (value !== undefined)
            reflectionMergePartial<BatchCreateTransactionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchCreateTransactionsRequest): BatchCreateTransactionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 import_id */ 1:
                    message.importId = reader.uint32();
                    break;
                case /* repeated transaction.ImportRow rows */ 2:
                    message.rows.push(ImportRow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchCreateTransactionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 import_id = 1; */
        if (message.importId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.importId);
        /* repeated transaction.ImportRow rows = 2; */
        for (let i = 0; i < message.rows.length; i++)
            ImportRow.internalBinaryWrite(message.rows[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.BatchCreateTransactionsRequest
 */
export const BatchCreateTransactionsRequest = new BatchCreateTransactionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportRowResult$Type extends MessageType<ImportRowResult> {
    constructor() {
        super("transaction.ImportRowResult", [
            { no: 1, name: "outcome", kind: "enum", T: () => ["transaction.ImportRowOutcome", ImportRowOutcome] },
            { no: 2, name: "transaction_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<ImportRowResult>): ImportRowResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.outcome = 0;
        message.transactionId = 0;
        if (value !== undefined)
            reflectionMergePartial<ImportRowResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImportRowResult): ImportRowResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* transaction.ImportRowOutcome outcome */ 1:
                    message.outcome = reader.int32();
                    break;
                case /* uint32 transaction_id */ 2:
                    message.transactionId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImportRowResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* transaction.ImportRowOutcome outcome = 1; */
        if (message.outcome !== 0)
            writer.tag(1, WireType.Varint).int32(message.outcome);
        /* uint32 transaction_id = 2; */
        if (message.transactionId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.transactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.ImportRowResult
 */
export const ImportRowResult = new ImportRowResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountStatementNames$Type extends MessageType<AccountStatementNames> {
    constructor() {
        super("transaction.AccountStatementNames", [
            { no: 1, name: "account", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "statement_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccountStatementNames>): AccountStatementNames {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.account = 0;
        message.statementNames = [];
        if (value !== undefined)
            reflectionMergePartial<AccountStatementNames>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountStatementNames): AccountStatementNames {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 account */ 1:
                    message.account = reader.uint32();
                    break;
                case /* repeated string statement_names */ 2:
                    message.statementNames.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountStatementNames, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 account = 1; */
        if (message.account !== 0)
            writer.tag(1, WireType.Varint).uint32(message.account);
        /* repeated string statement_names = 2; */
        for (let i = 0; i < message.statementNames.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.statementNames[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.AccountStatementNames
 */
export const AccountStatementNames = new AccountStatementNames$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchCreateTransactionsResponse$Type extends MessageType<BatchCreateTransactionsResponse> {
    constructor() {
        super("transaction.BatchCreateTransactionsResponse", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ImportRowResult },
            { no: 2, name: "accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccountStatementNames }
        ]);
    }
    create(value?: PartialMessage<BatchCreateTransactionsResponse>): BatchCreateTransactionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.accounts = [];
        if (value !== undefined)
            reflectionMergePartial<BatchCreateTransactionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BatchCreateTransactionsResponse): BatchCreateTransactionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated transaction.ImportRowResult results */ 1:
                    message.results.push(ImportRowResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated transaction.AccountStatementNames accounts */ 2:
                    message.accounts.push(AccountStatementNames.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BatchCreateTransactionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated transaction.ImportRowResult results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ImportRowResult.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated transaction.AccountStatementNames accounts = 2; */
        for (let i = 0; i < message.accounts.length; i++)
            AccountStatementNames.internalBinaryWrite(message.accounts[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message transaction.BatchCreateTransactionsResponse
 */
export const BatchCreateTransactionsResponse = new BatchCreateTransactionsResponse$Type();
/**
 * @generated ServiceType for protobuf service transaction.TransactionService
 */
export const TransactionService = new ServiceType("transaction.TransactionService", [
    { name: "GetAllTransactions", options: {}, I: GetAllTransactionsRequest, O: GetAllTransactionsResponse },
    { name: "CreateTransaction", options: {}, I: CreateTransactionRequest, O: CreateTransactionResponse },
    { name: "UpdateTransaction", options: {}, I: UpdateTransactionRequest, O: UpdateTransactionResponse },
    { name: "DeleteTransaction", options: {}, I: DeleteTransactionRequest, O: DeleteTransactionResponse },
    { name: "BatchCreateTransactions", options: {}, I: BatchCreateTransactionsRequest, O: BatchCreateTransactionsResponse }
]);
